import { gql } from "graphql-request";
import client from '../client';

export default (name, email, message) => client.request(
    gql`
        mutation sendMessage($name:String, $email:String, $message:String) {
            createMessage(data: {name: $name, email: $email, message: $message}) {
                id
            }
        }
    `
, {name: name, email: email, message: message});